export const AmountTypeEnum = {
  SenderAmount: 'SenderAmount',
  BeneficiaryAmount: 'BeneficiaryAmount',
} as const;
export type AmountTypeEnum = (typeof AmountTypeEnum)[keyof typeof AmountTypeEnum];
